import {
  useEnabledFeatures,
  useRoutePermission,
  useTeamPermission,
} from '@vrplatform/data';

/**
 * Banking access shared by navigation, the route and the view, so a visible
 * link always renders: `full` with bank record reads, `paymentBatches` for an
 * ACH Payer without them, who sees only the Nacha files and check runs.
 */
export function useBankingAccess(): 'full' | 'paymentBatches' | null {
  const canReadReconciliation = useRoutePermission('reconciliation');
  const canExecuteAchPayments = useTeamPermission('ach-payments:execute');
  const { ACH } = useEnabledFeatures();

  if (canReadReconciliation) return 'full';
  return ACH && canExecuteAchPayments ? 'paymentBatches' : null;
}
